import { Link } from "react-router-dom";
import InstalarCorvana from "../../../shared/components/InstalarCorvana";
import { useLang } from "../../../shared/i18n/useLang";
import { useTheme } from "../../../shared/contexts/ThemeContext";
// Página pública (no pasa por Layout): carga ella misma las variables de tema.
import "../../../shared/styles/main.css";

/**
 * /instalar — el link que se manda por WhatsApp para instalar Corvana en el
 * celular. Es pública: la persona la abre sin haber iniciado sesión, instala
 * la app y entra con su usuario desde el ícono nuevo.
 */
export default function InstalarPage() {
  const L = useLang();
  const { theme, toggleTheme } = useTheme();
  const conSesion = !!localStorage.getItem("access_token");

  return (
    <div style={{ minHeight: "100dvh", background: "var(--bg)", padding: "24px 16px 40px" }}>
      <div style={{ maxWidth: 520, margin: "0 auto", display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button type="button" onClick={toggleTheme}
            aria-label={L("Cambiar tema", "Change theme")}
            style={{ width: 40, height: 40, borderRadius: 10, border: "1px solid var(--border-card)",
              background: "var(--bg-card)", color: "var(--text-secondary)", cursor: "pointer" }}>
            <i className={`fa-solid ${theme === "light" ? "fa-moon" : "fa-sun"}`} style={{ color: "inherit" }} />
          </button>
        </div>

        <InstalarCorvana modo="pagina" />

        <Link to={conSesion ? "/" : "/login"} style={{
          minHeight: 50, borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center",
          gap: 8, fontWeight: 700, fontSize: 15, textDecoration: "none",
          background: "var(--bg-card)", border: "1px solid var(--border-card)", color: "var(--text-primary)",
        }}>
          <i className="fa-solid fa-right-to-bracket" style={{ color: "var(--brand)" }} />
          {conSesion ? L("Ir a Corvana", "Go to Corvana") : L("Iniciar sesión en el navegador", "Log in on the browser")}
        </Link>
        <p style={{ textAlign: "center", fontSize: 13, color: "var(--text-secondary)", margin: 0 }}>
          {L("¿Todavía no tenés usuario? Pedile a la administración de tu condominio que te mande la invitación.",
             "Don't have a user yet? Ask your condominium's administration to send you the invitation.")}
        </p>
      </div>
    </div>
  );
}
